import { Faq, type FaqItem } from "components/website";

/**
 * Credit-model FAQ. Shared with the standalone FAQ page so the two can never
 * describe the pricing model differently.
 */
export const creditFaqItems: FaqItem[] = [
  {
    question: "Do my credits expire?",
    answer:
      "Your weekly credits refresh every week. Purchased credits are valid for 90 days, giving you plenty of time to use them across your hiring campaigns.",
  },
  {
    question: "Do I need a subscription?",
    answer:
      "No. Precision is built around pay-as-you-assess, so you don't need monthly subscriptions or seat licenses. Use your 100 weekly credits or top up anytime when you need additional AI-powered candidate evaluations and hiring insights.",
  },
  {
    question: "Can I create unlimited jobs?",
    answer:
      "Yes. Hiring campaigns, applicants, and recruiter seats are unlimited. Credits are only consumed when AI analysis is performed.",
  },
  {
    question: "When are credits used?",
    answer: (
      <>
        <p>Only when you ask Precision's AI to perform actions such as:</p>
        <ul className="list-disc ps-[30px] mt-1">
          {[
            "Creating an AI assessment",
            "Evaluating a candidate",
            "Analysing a CV",
            "Comparing candidates",
            "Generating hiring insights",
          ].map((action) => (
            <li key={action}>{action}</li>
          ))}
        </ul>
      </>
    ),
  },
];

const PricingFaqSection = () => {
  return <Faq faqItems={creditFaqItems} />;
};

export { PricingFaqSection };
